import { createSlice } from '@reduxjs/toolkit'
import { 
  createUpdateClient, 
  fetchClientList, 
  deleteClient,
  toggleActivation, 
  sendActivationLink, 
  sendResetPasswordLink,
  getClientByClientId,  
  downLoadReport} from '../actions/clientsAction'

export const clients = createSlice({
  name: 'clients',
  initialState: {
    clients: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded:false,
    isManageClientPage:false,
    downloadClientList: null,
  },
  reducers: {
    userReset: state => {
      // state.clients= null;
      state.error = null;
    },

   
    resetPopup: state => {
      state.isLoader= false;
      state.isRecordAdded= false;
      state.isRecordUpdated= false;
      state.error=null;
    },
    setManageClientPage: state => {
      state.isManageClientPage = true;
    },
    resetManageClientPage: state => {
      state.isManageClientPage = false;
    }
  },
  extraReducers: {
    [fetchClientList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchClientList.fulfilled]: (state, {payload}) => {
      state.error=null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false
      }
    },
    [fetchClientList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },
    [createUpdateClient.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [createUpdateClient.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [createUpdateClient.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [deleteClient.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [deleteClient.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [deleteClient.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [toggleActivation.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [toggleActivation.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [toggleActivation.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [sendActivationLink.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [sendActivationLink.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [sendActivationLink.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [sendResetPasswordLink.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [sendResetPasswordLink.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [sendResetPasswordLink.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [getClientByClientId.pending]: (state, payload) => {
      state.error=null;
      state.isRecordLoaded= false;
      state.isLoader= true;
      
    },
    [getClientByClientId.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordLoaded= true
      state.isLoader= false;
    },
    [getClientByClientId.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordLoaded= false;
      state.isLoader= false;
    },

    [downLoadReport.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadReport.fulfilled]: (state, { payload }) => {
      state.error = null;
      console.log("payload",payload);
      state.downloadClientList = payload?.data?.filePath;
      state.isLoader = false;
    },
    [downLoadReport.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    
  }
})

// Action creators are generated for each case reducer function
export const { userReset, userSort, userSearch, resetPopup, setManageClientPage, resetManageClientPage } = clients.actions

// const myData = [].concat(this.state.data)
//     .sort((a, b) => a.itemM > b.itemM ? 1 : -1)     
//     .map((item, i) => 
//         <div key={i}> {item.matchID} {item.timeM}{item.description}</div>
//     );

export default clients.reducer